import apiClient from './client';
import { API_ENDPOINTS } from './config';
import type { RevenueQueryParams, RevenueResponse } from '../types/revenue';

const buildQuery = (params: RevenueQueryParams): string => {
	const qs = new URLSearchParams();
	qs.set('locationId', String(params.locationId));
	if (params.period) qs.set('period', params.period);
	if (params.dateFrom) qs.set('dateFrom', params.dateFrom);
	if (params.dateTo) qs.set('dateTo', params.dateTo);
	if (params.staffId != null) qs.set('staffId', String(params.staffId));
	if (params.service) qs.set('service', params.service);
	return `?${qs.toString()}`;
};

export const revenueApi = {
	getRevenue: async (params: RevenueQueryParams): Promise<RevenueResponse> => {
		return apiClient.get<RevenueResponse>(
			`${API_ENDPOINTS.PROVIDER.REVENUE}${buildQuery(params)}`
		);
	},
};
